import styled from '@emotion/styled';

const Container = styled.div`
  padding: 0 0.5rem;
  margin-right: auto;
  margin-left: auto;

  @media only screen and (min-width: 769px) {
    width: 737px;
  }

  @media only screen and (min-width: 1024px) {
    width: 992px;
  }

  @media screen and (min-width: 1216px) {
    width: 1184px;
  }
`;

export default Container;
